export default __webpack_public_path__ + "static/media/outpatient.89ff1bcd.svg";